import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="m11 3 8 8-8 8-1.62-1.595 5.245-5.27H3V9.865h11.625L9.381 4.619 11 3Z" />
  </svg>
);
